import { ContentType } from '../../models';
import { BaseComponent } from '../base.component';

export abstract class BaseContentComponent<T extends ContentType> extends BaseComponent<T> {
    protected override bindEvent = undefined;
}
